// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchResults-loadingOverlay-KT0rB {
	position: absolute;
	height: 100%;
	width: 100%;
	z-index: 2;
	background: rgba(255, 255, 255, 0.5);
	left: 0;
	right: 0;
	bottom: 0;
	top: 0;
}

.SearchResults-searchResults-QXkoU {
	position: relative;
	padding: 24px 16px 33px;
	margin-bottom: 50px;
}

.SearchResults-resultsFooter-berQA {
	padding: 20px;
	position: relative;
}

.SearchResults-listItem-JOc_L {
	width: 25%;
	padding: 0px 17px 33px;
}

.SearchResults-resultsPagination-hrPPm {
	margin-bottom: 48px;
	position: relative;
}

@media screen and (min-width: 768px) and (max-width: 1199px) {
	.SearchResults-listItem-JOc_L {
		width: 50%;
	}
}

@media screen and (max-width: 767px) {
	.SearchResults-listItem-JOc_L {
		width: 100%;
	}

	.SearchResults-searchResults-QXkoU {
		padding: 24px 7px 33px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/SearchListing/SearchResults/SearchResults.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,UAAU;CACV,oCAAoC;CACpC,OAAO;CACP,QAAQ;CACR,SAAS;CACT,MAAM;AACP;;AAEA;CACC,kBAAkB;CAClB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC;EACC,UAAU;CACX;AACD;;AAEA;CACC;EACC,WAAW;CACZ;;CAEA;EACC,sBAAsB;CACvB;AACD","sourcesContent":[".loadingOverlay {\n\tposition: absolute;\n\theight: 100%;\n\twidth: 100%;\n\tz-index: 2;\n\tbackground: rgba(255, 255, 255, 0.5);\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\ttop: 0;\n}\n\n.searchResults {\n\tposition: relative;\n\tpadding: 24px 16px 33px;\n\tmargin-bottom: 50px;\n}\n\n.resultsFooter {\n\tpadding: 20px;\n\tposition: relative;\n}\n\n.listItem {\n\twidth: 25%;\n\tpadding: 0px 17px 33px;\n}\n\n.resultsPagination {\n\tmargin-bottom: 48px;\n\tposition: relative;\n}\n\n@media screen and (min-width: 768px) and (max-width: 1199px) {\n\t.listItem {\n\t\twidth: 50%;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.listItem {\n\t\twidth: 100%;\n\t}\n\n\t.searchResults {\n\t\tpadding: 24px 7px 33px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingOverlay": `SearchResults-loadingOverlay-KT0rB`,
	"searchResults": `SearchResults-searchResults-QXkoU`,
	"resultsFooter": `SearchResults-resultsFooter-berQA`,
	"listItem": `SearchResults-listItem-JOc_L`,
	"resultsPagination": `SearchResults-resultsPagination-hrPPm`
};
module.exports = ___CSS_LOADER_EXPORT___;
